


































































import { Component, Vue } from "vue-property-decorator";
import { containsWoCaseMultipleFn } from "@/helper/global-helper";
import BeraterGruppeDto from "../types/BeraterGruppeDto";
import BeraterGruppeApi from "../api/BeraterGruppeAPI";

@Component({})
export default class StandorteList extends Vue {
  private beraterGruppenService!: BeraterGruppeApi;

  public beraterGrupppen: BeraterGruppeDto[] = [];

  public filter: string = "";
  public loading: boolean = true;

  async created() {
    this.beraterGruppenService = new BeraterGruppeApi();
  }

  async mounted() {
    this.beraterGrupppen = await this.beraterGruppenService.GetBeraterGruppen();
    this.loading = false;
  }

  get filteredBeraterGruppen() {
    return this.beraterGrupppen.filter((x) =>
      containsWoCaseMultipleFn(this.filter, x.Name)
    );
  }
}
